export async function getGuideBlobUseCase(path, guideRepostitory) {
    const result = await guideRepostitory.get_blob(path);

    return result;
}